import type { IconSvgObject } from './types';

const Tally1Icon: IconSvgObject = [
  ["path", { d: "M12 4V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Tally1Icon;
